import _ from 'lodash';

export const incrementStep = () => (dispatch, getState) => {
  const { step = 1 } = getState()
  setStep(step + 1)(dispatch, getState);
};

export const decrementStep = () => (dispatch, getState) => {
  const { step = 1 } = getState()
  setStep(step - 1)(dispatch, getState);
};

export const setOverSixtyDays = (value) => (dispatch) => {
  dispatch({
    type: "SET_OVER_SIXTY",
    overSixtyDays: value,
  });
}

export const setNotClosed = (value) => (dispatch) => {
  dispatch({
    type: "SET_NOT_CLOSED",
    notClosedYet: value,
  });
}

export const verifyAddress = () => (dispatch, getState) => {
  const { formData, step, metadata } = getState();
  var property = {}

  if (step === 3) {
    property = formData.ownerAddress
  } else {
    property = formData.propertyAddress
  }

   fetch((MDMS_URL + `/api/v1/smarty/verification`),
  {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(
      {
        street_1: property.street,
        street_2: property.streetLine2,
        city: property.city,
        state_province: property.state,
        country_code: property.country,
        postal_code: property.zip,
      }
    )
  })
    .then(response => response.json())
    .then(jsonData => {
      if (step === 3) {
        metadata.suggestedOwner = {
          street: jsonData.street_1,
          streetLine2: jsonData.street_2,
          city: jsonData.city,
          state: jsonData.state_province,
          zip: jsonData.postal_code
        }
      } else {
        metadata.suggestedProperty = {
          street: jsonData.street_1,
          streetLine2: jsonData.street_2,
          city: jsonData.city,
          state: jsonData.state_province,
          zip: jsonData.postal_code
        }
      }
    })
    .catch(err => {
      metadata.suggestedProperty = []
      metadata.suggestedOwner = []
      console.log(err);
    }).finally(() => {
      if ( (step === 3 ) && (formData.ownerAddressSameAsProperty === "true")) {
        incrementStep()(dispatch, getState);
      } else {
        dispatch({
          type: "SHOW_MODAL",
          showModal: true,
        });
      }
    })
}

export const showModal = () => (dispatch) => {
  dispatch({
    type: "SHOW_MODAL",
    showModal: true,
  });
}

export const hideModal = () => (dispatch) => {
  dispatch({
    type: "SHOW_MODAL",
    showModal: false,
  });
}

export const setStep = (newStep) => (dispatch, getState) => {
  const { step } = getState()
  if (step != newStep) {
    dispatch({
      type: 'SET_STEP',
      stepNum: newStep
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

export const setFormData = (hash) => (dispatch, getState) => {
  dispatch({
    type: 'SET_FORM_DATA',
    hash: hash
  });
};

export const setAppData = (hash) => (dispatch) => {
  dispatch({
    type: 'SET_APP_DATA',
    hash: hash
  });
}
